export const mutations = {

    STORE_CUSTOMERS (state, customers){
        state.customers = customers
    },
    STORE_CUSTOMER_UPDATE (state, customerId) {
        let Customer = state.customers.find(function (customer) {
            return customer.id === customerId
        })
        state.systemCustomer = Customer
    }
}
export default mutations


// WEBPACK FOOTER //
// ./src/vuex/modules/customers/mutations.js